// i18next configuration
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translation files
import translationsAr from '@/locales/ar.json'
import translationsFr from '@/locales/fr.json'

const resources = {
  ar: {
    translation: translationsAr,
  },
  fr: {
    translation: translationsFr,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ar',
    supportedLngs: ['ar', 'fr'],

    // Language detection
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'digimataam-language',
    },

    // React i18next options
    react: {
      useSuspense: true,
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    // Performance
    load: 'languageOnly',

    // Debug in development
    debug: import.meta.env.DEV,
  })

// Update document direction and lang attribute when language changes
i18n.on('languageChanged', (lng) => {
  const direction = lng === 'ar' ? 'rtl' : 'ltr'
  document.documentElement.dir = direction
  document.documentElement.lang = lng
})

// Set initial direction
const initialLng = i18n.language
const initialDirection = initialLng === 'ar' ? 'rtl' : 'ltr'
document.documentElement.dir = initialDirection
document.documentElement.lang = initialLng

export default i18n
